<style lang="scss" scoped>
.nav-search {
    position: relative;
    z-index: 100;
    // margin-right: 50px;
}
.nav-search-down {
    outline: none !important;
    position: absolute;
    top: 50px;
    left: 0;
    // min-width: 30vw;
    // max-width: 50vw;
    // min-height: 60vh;
    // min-width: 500px;
    // max-width: 600px;
    width: 500px;
    max-height: 700px;
    overflow-y: auto;
    z-index: 100;
    background-color: #fff;
    padding: 10px 10px 10px;
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 3px;
    box-shadow: 1px 1px 5px #ddd;
}
.no-search-title {
    padding: 10px;
    padding-left: 0;
    padding-bottom: 30px;
    font-size: 16px;
    color: #ccc;
}
.recommend-content {
    width: 100%;
    flex: 1;
}

.search-recommend {
    padding: 10px 0;
    width: 100%;
    border-bottom: 1px solid #eee;
    display: flex;

    .recommend-item {
        padding: 3px 5px;
        margin-right: 10px;
        border: 1px solid #ddd;
        color: #666;
        border-radius: 5px;
        cursor: pointer;
    }
}
.search-content {
    // display: flex;
    padding: 10px;

    .search-title {
        font-size: 14px;
        cursor: pointer;
    }
}
.flex-content {
    display: flex;
    padding-top: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    min-height: 110px;
    justify-content: space-between;
}
.search-list {
    padding-top: 10px;

    .search-item {
        padding: 3px 0;
        margin: 5px 0;
        cursor: pointer;
        color: #666;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
    }
}
.announce-content {
    width: 49%;
}
.product-content {
    width: 49%;
}
.order-content {
    width: 49%;
}
.menu-content {
    width: 49%;
}
.notice-content {
    position: absolute;
    left: 20px;
}
</style>

<template>
    <aside class="nav-search">
        <Input
            class="nav-search-input"
            prefix="ios-search"
            :placeholder="
                $t('fe.home.Order_Product', {
                    defaultValue: '订单/产品/菜单/采购',
                })
            "
            style="width: auto"
            v-model="searchText"
            clearable
        />
        <div class="nav-search-down" v-if="visible">
            <div v-if="showNotice" class="notice-content color-error">
                {{
                    $t("fe.home.Tip_more_characters", {
                        defaultValue: "提示：2个及以上字符才会触发搜索",
                    })
                }}
            </div>
            <div class="search-content">
                <!-- <div class="recommend-content">
                    <div class="recommend-title">你是不是想搜</div>
                    <ul class="search-recommend">
                        <li
                            v-for="item in recommendList"
                            :key="item.key"
                            class="recommend-item"
                            @click="setSearchText(item.title)"
                        >{{item.title}}</li>
                    </ul>
                </div>-->
                <!-- <div v-if="orderList.length === 0 && menuList.length === 0 && otherList.length === 0" class="no-search-title">暂无搜索结果</div> -->
                <!-- <div v-else> -->
                <!-- <div> -->
                <div class="flex-content">
                    <div class="order-content">
                        <div class="search-title" @click="handlePage('Order')">
                            {{
                                $t("fe.home.order", {
                                    defaultValue: "订单",
                                })
                            }}（ {{ order.length }}）
                            <Icon type="ios-arrow-forward" />
                        </div>
                        <div
                            v-if="order.list.length === 0"
                            class="no-search-title"
                        >
                            {{
                                $t("fe.home.currently_no", {
                                    defaultValue: "暂无相关内容",
                                })
                            }}
                        </div>
                        <ul v-else class="order-list search-list">
                            <li
                                class="order-item search-item"
                                v-for="item in order.list"
                                :key="item.key"
                                @click="handleItemUrl(item, 'Order')"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                    </div>
                    <div class="product-content">
                        <div
                            class="search-title product-title"
                            @click="handlePage('Product')"
                        >
                            {{
                                $t("fe.home.product", {
                                    defaultValue: "产品",
                                })
                            }}（{{ product.length }}）
                            <Icon type="ios-arrow-forward" />
                        </div>
                        <div
                            v-if="product.list.length === 0"
                            class="no-search-title"
                        >
                            {{
                                $t("fe.home.currently_no", {
                                    defaultValue: "暂无相关内容",
                                })
                            }}
                        </div>
                        <ul v-else class="product-list search-list">
                            <li
                                class="product-item search-item"
                                v-for="item in product.list"
                                :key="item.key"
                                @click="handleItemUrl(item, 'Product')"
                            >
                                <span
                                    v-html="setHighLightText(item.title)"
                                ></span>
                                <!-- <span
                                        style="margin-left: 10px;"
                                        v-html="setHighLightText(item.title)"
                                ></span>-->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="flex-content">
                    <div class="po-content">
                        <div class="search-title" @click="handlePage('PO')">
                            {{
                                $t("fe.home.purchase", {
                                    defaultValue: "采购",
                                })
                            }}（{{ po.length }}）
                            <Icon type="ios-arrow-forward" />
                        </div>
                        <div
                            v-if="po.list.length === 0"
                            class="no-search-title"
                        >
                            {{
                                $t("fe.home.currently_no", {
                                    defaultValue: "暂无相关内容",
                                })
                            }}
                        </div>
                        <ul v-else class="po-list search-list">
                            <li
                                class="po-item search-item"
                                v-for="item in po.list"
                                :key="item.key"
                                @click="handleItemUrl(item, 'PO')"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                    </div>
                    <div class="menu-content">
                        <div class="search-title">
                            {{
                                $t("fe.home.menu", {
                                    defaultValue: "菜单",
                                })
                            }}（{{ menuList.length }}）
                        </div>
                        <div
                            v-if="menuList.length === 0"
                            class="no-search-title"
                        >
                            {{
                                $t("fe.home.currently_no", {
                                    defaultValue: "暂无相关内容",
                                })
                            }}
                        </div>
                        <ul v-else class="menu-list search-list">
                            <li
                                class="menu-item search-item"
                                v-for="item in menuList"
                                :key="item.key"
                                @click="handleUrl(item)"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="flex-content">
                    <div class="announce-content">
                        <div class="search-title" @click="handlePage('UcAnnouncement')">
                            公告（{{announce.length}}）
                            <Icon type="ios-arrow-forward" />
                        </div>
                        <div v-if="announce.list.length === 0" class="no-search-title">暂无相关内容</div>
                        <ul v-else class="announce-list search-list">
                            <li
                                class="announce-item search-item"
                                v-for="item in announce.list"
                                :key="item.key"
                                @click="handleItemUrl(item, 'UcAnnouncement')"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                    </div>
                    <div class="menu-content">
                        <div class="search-title">菜单（{{menuList.length}}）</div>
                        <div v-if="menuList.length === 0" class="no-search-title">暂无相关内容</div>
                        <ul v-else class="menu-list search-list">
                            <li
                                class="menu-item search-item"
                                v-for="item in menuList"
                                :key="item.key"
                                @click="handleUrl(item)"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                    </div>
                </div> -->
                <!-- <div class="other-content">
                        <div class="search-title">其他</div>
                        <div v-if="otherList.length === 0" class="no-search-title">暂无相关内容</div>
                        <ul v-else class="search-list other-list">
                            <li
                                class="search-item other-item"
                                v-for="item in otherList"
                                :key="item.key"
                                v-html="setHighLightText(item.title)"
                            ></li>
                        </ul>
                </div>-->
                <!-- </div> -->
            </div>
        </div>
    </aside>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import {
    HttpNavMenu,
    HttpSearchAnnounce,
    HttpSearchOrder,
    HttpSearchProduct,
    HttpSearchPO,
} from "../../../../service/base";
export default {
    watch: {
        searchText: {
            handler(val) {
                // 输入为空时重置所有
                if (!val) {
                    clearTimeout(this.timeOut);
                    return this.reset();
                }
                if (!this.preDate) {
                    this.handleInput(val);
                    this.preDate = Date.now();
                } else {
                    if (Date.now() - this.preDate < this.wait) {
                        clearTimeout(this.timeOut);
                        // 为防止最后一次输入与上次间隔小于wait导致不搜索，最后再触发一次
                        this.timeOut = setTimeout(() => {
                            this.handleInput(val);
                            this.preDate = Date.now();
                        }, this.wait);
                    } else {
                        clearTimeout(this.timeOut);
                        this.handleInput(val);
                        this.preDate = Date.now();
                    }
                }
            },
        },
    },
    data() {
        return {
            // 节流
            timeOut: null,
            wait: 500,
            preDate: null,
            searchText: "",
            visible: false,
            // noResult: false,
            recommendList: [
                {
                    title: this.$t("erp.product.product_management", {
                        defaultValue: "产品管理",
                    }),
                    url: "",
                },
                {
                    title: this.$t("erp.b2c.channel", {
                        defaultValue: "渠道",
                    }),
                    url: "",
                },
            ],
            menuList: [],
            announce: {
                list: [],
                length: 0,
                size: 5,
            },
            po: {
                list: [],
                length: 0,
                size: 5,
            },
            product: {
                list: [],
                length: 0,
                size: 5,
            },
            order: {
                list: [],
                length: 0,
                size: 5,
            },
            otherList: [],
            moduleMap: {
                Order: {
                    scope: 8,
                    url: "/home/b2corder/upadte/query",
                    listUrl: "/home/b2corder",
                    host: "",
                    isVue: false,
                },
                Product: {
                    scope: 8,
                    url: "/home/products/allproducts/update/query",
                    listUrl: "/home/products/allproducts/list",
                    host: "",
                    isVue: false,
                },
                UcAnnouncement: {
                    listUrl: "/home/announce/list",
                    url: "/home/announce/detail",
                    host: "",
                    isVue: true,
                },
                PO: {
                    scope: 8,
                    listUrl: "/home/purchase/order/list",
                    url: "/home/purchase/order/update/query",
                    host: "",
                    isVue: false,
                },
            },
            showNotice: false,
        };
    },
    computed: {
        ...mapState("layout", ["moduleList", "sysScopeList"]),
        ...mapGetters("layout", ["getModuleMap", "getMenuList"]),
        // ...mapState('layout', ['']),
    },
    created() {
        // 处理每个模块的域名和跳转方式
        this.handleModuleHost();
    },
    mounted() {
        console.log("env", process.env);
        document.addEventListener("click", this.handleClickOut, false);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOut);
    },
    methods: {
        ...mapMutations("layout", ["setRouteId"]),
        // 处理域名
        handleModuleHost() {
            Object.keys(this.moduleMap).map((moduleName) => {
                if (moduleName === "UcAnnouncement") {
                    this.moduleMap[moduleName].host =
                        this.sysScopeList[process.env.VUE_APP_PROJECT_ID].url;
                    this.moduleMap[moduleName].isVue = true;
                } else {
                    this.moduleMap[moduleName].isVue = (() => {
                        return (
                            this.moduleMap[moduleName].scope ===
                            process.env.VUE_APP_PROJECT_ID
                        );
                    })();
                    this.moduleMap[moduleName].host = (() => {
                        return this.sysScopeList[
                            this.moduleMap[moduleName].scope
                        ].url;
                    })();
                }
            });
        },
        async searchAnnounce(keyword) {
            return await HttpSearchAnnounce({
                keyword: keyword,
                size: this.announce.size,
            });
        },
        async searchOrder(keyword) {
            return await HttpSearchOrder({
                keyword: keyword,
                size: this.order.size,
            });
        },
        async searchProduct(keyword) {
            return await HttpSearchProduct({
                keyword: keyword,
                size: this.product.size,
            });
        },
        async searchPO(keyword) {
            return await HttpSearchPO({
                keyword: keyword,
                size: this.po.size,
            });
        },
        // 全部清空后重置状态
        reset() {
            this.searchText = "";
            this.visible = false;
            this.preDate = null;
            this.showNotice = false;
            this.menuList = [];
            this.announce.list = [];
            this.announce.length = 0;
            this.product.list = [];
            this.product.length = 0;
            this.order.list = [];
            this.order.length = 0;
            this.po.list = [];
            this.po.length = 0;
        },
        closeSearch() {
            this.visible = false;
        },
        // handleAnnounce(item) {
        //     // this.$router.push({
        //     //     path: this.moduleMap['UcAnnouncement'].url,
        //     //     query: {
        //     //         id: item.id,
        //     //     },
        //     // });
        //     let url = `${routerItem.host}${routerItem.url}?id=${item.id}`
        //         window.open(url, "_blank");
        //     this.closeSearch()
        // },
        // 前端详情页跳转
        handleItemUrl(item, moduleName) {
            let routerItem = this.moduleMap[moduleName];
            // if (routerItem.isVue) {
            //     this.$router.push({
            //         path: routerItem.url,
            //         query: {
            //             id: item.id
            //         }
            //     })
            // }
            // else {
            let url = `${routerItem.host}${routerItem.url}?id=${item.id}`;
            window.open(url, "_blank");
            // }
            this.closeSearch();
        },
        // 前端搜索模块列表
        navSearch(text) {
            // 如果搜索的字数小于2就不搜索
            if (text.length < 2) return (this.showNotice = true);
            else this.showNotice = false;
            this.searchAnnounce(text).then((res) => {
                this.announce.length = res.data.total;
                this.announce.list = res.data.items.map((item) => {
                    return {
                        ...item,
                    };
                });
            });
            this.searchOrder(text).then((res) => {
                // console.log("订单搜索", res);
                this.order.length = res.data.total;
                this.order.list = res.data.items.map((item) => {
                    return {
                        ...item,
                    };
                });
            });
            this.searchProduct(text).then((res) => {
                // console.log("产品搜索", res);
                this.product.length = res.data.total;
                this.product.list = res.data.items.map((item) => {
                    return {
                        ...item,
                    };
                });
            });
            this.searchPO(text).then((res) => {
                // console.log("采购搜索", res);
                this.po.length = res.data.total;
                this.po.list = res.data.items.map((item) => {
                    return {
                        ...item,
                    };
                });
            });
            this.menuList = [];
            if (!text) return;
            let keyList = Object.keys(this.getMenuList).filter((key) => {
                if (this.getMenuList[key].title.indexOf(text) >= 0) {
                    return this.getMenuList[key];
                }
            });
            this.menuList = keyList
                .map((id) => {
                    return this.getMenuList[id];
                })
                .filter((item) => {
                    return item.menuType === "YES" && item.depth >= 3;
                });
            // for (let index in this.moduleList) {
            //     if (!this.getModuleMap[index]) continue;
            //     this.getModuleMap[index].map((item) => {
            //         if (this.menuList.length === 5) return
            //         if (item.title.indexOf(text) >= 0) {
            //             this.menuList.push(item);
            //         }
            //     });
            // }
        },
        /**
         * 获取默认路由数据
         * @param {*} state
         * @param {*} getters
         */
        getRouteData(data) {
            const { linklistId = [], moduleId } = data,
                menuList = this.getMenuList;
            if (linklistId) {
                const getChildRouteId = function (linklistId, moduleId) {
                    return linklistId.reduce((pre, cur, index, arr) => {
                        if (pre) return pre;
                        const routeData = menuList[cur];
                        const _moduleId = routeData.moduleId;
                        const hasModuleId = !_moduleId || _moduleId == moduleId;
                        if (!hasModuleId) return;
                        if (routeData.linklistId) {
                            return getChildRouteId(
                                routeData.linklistId,
                                moduleId
                            );
                        }
                        return cur;
                    }, null);
                };
                const routeId = getChildRouteId(linklistId, moduleId);
                if (routeId) data = menuList[routeId];
            }
            return data;
        },
        // 跳转列表页
        handlePage(type) {
            let routerItem = this.moduleMap[type];
            // if (routerItem.isVue) {
            //     this.$router.push({
            //         path: routerItem.listUrl,
            //         query: {
            //             keyword: this.searchText,
            //         },
            //     });
            // } else {
            // let url = `${routerItem.host}${routerItem.listUrl}?keyword=${this.searchText}`;
            let url = `${routerItem.host}${routerItem.listUrl}`;
            window.open(url, "_blank");
            // }
            this.closeSearch();
        },
        handleInput(val) {
            this.visible = true;
            this.navSearch(val);
        },
        handleClickOut(e) {
            if (this.$el.contains(e.target)) return (this.visible = true);
            this.visible = false;
        },
        // 前端模块搜索跳转
        handleUrl(data, isVue) {
            data = this.getRouteData(data);
            if (data.isVue) {
                this.$nextTick(() => {
                    this.setRouteId(data.id);
                    this.$router.push(data.props.to);
                });
            } else {
                window.open(data.props.href, "_blank");
            }
            this.closeSearch();
        },
        // 搜索高亮显示
        setHighLightText(text) {
            if (!this.searchText) return text;
            let index = text.indexOf(this.searchText);
            if (index < 0) return text;
            let length = this.searchText.length;
            let html = text.replace(
                this.searchText,
                `<span style="color: #ffc761; font-weight: bold;">${this.searchText}</span>`
            );
            return html;
        },
        setSearchText(text) {
            this.searchText = text;
        },
    },
};
</script>
